import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try { await signIn(form.username, form.password); navigate('/'); }
    catch (err) { setError(err.response?.data?.error || 'Erreur de connexion'); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <div className="login-logo-icon">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="#fff"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
          </div>
          <div>
            <div style={{fontSize:22,fontWeight:700,color:'#1a3a5c'}}>GFM3</div>
            <div style={{fontSize:12,color:'#888'}}>Gestion des Ressources Humaines</div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="fg" style={{marginBottom:12}}>
            <label>Nom d'utilisateur</label>
            <input type="text" placeholder="admin" value={form.username}
              onChange={e=>setForm(f=>({...f,username:e.target.value}))} required autoFocus />
          </div>
          <div className="fg" style={{marginBottom:18}}>
            <label>Mot de passe</label>
            <input type="password" placeholder="••••••••" value={form.password}
              onChange={e=>setForm(f=>({...f,password:e.target.value}))} required />
          </div>

          {error && (
            <div style={{background:'#ffebee',border:'1px solid #ef9a9a',borderRadius:6,padding:'8px 12px',color:'#c62828',fontSize:13,marginBottom:14}}>
              ⚠️ {error}
            </div>
          )}

          <button type="submit" className="btn btn-green"
            style={{width:'100%',justifyContent:'center',padding:'10px',fontSize:14}}
            disabled={loading}>
            {loading ? <><span className="spinner"/>  Connexion…</> : '🔐 Se connecter'}
          </button>
        </form>

        <div style={{marginTop:20,padding:12,background:'#f5f7fa',borderRadius:6,fontSize:11,color:'#888'}}>
          <strong>Compte par défaut :</strong> admin / password
        </div>
      </div>
    </div>
  );
}
